import Vsporte from "../assets/Vsporte";
import Steklo from "../assets/Steklo";
import Gazprom from "../assets/Gazprom";
import Rennisanse from "../assets/Rennisanse";
import GoldenApple from "../assets/GoldenApple";
import Medsi from "../assets/Medsi";
import Sber from "../assets/Sber";
import Lock from "../assets/Lock";
import Wallet from "../assets/Wallet";
import Cart from "../assets/Cart";
import Web from "../assets/Web";
import Heart from "../assets/Heart";
import Robot from "../assets/Robot";
import Echelon from "../../content/assets/Echelon";

export interface SpheresDataType {
  title: string;
  desc: string;
  Svg: () => JSX.Element;
  logoData: (() => JSX.Element)[];
}

export const spheresData: SpheresDataType[] = [
  {
    title: "Финтех",
    desc: "Делаем финансовые услуги более доступными, эффективными и удобными. Повышаем безопасность и надежность транзакций, снижая операционные затраты и улучшая пользовательский опыт. Наши решения помогают как частным клиентам, так и бизнесу оптимизировать финансовые операции, обеспечивая высокую скорость и прозрачность процессов.",
    Svg: Wallet,
    logoData: [Sber, Gazprom],
  },
  {
    title: "E-commerce",
    desc: "Помогаем бизнесам эффективно использовать возможности электронной коммерции для увеличения продаж и расширения клиентской базы. Обеспечиваем высокое качество пользовательского опыта, быстрые и безопасные транзакции, а также эффективное управление.",
    Svg: Cart,
    logoData: [Steklo, GoldenApple],
  },
  {
    title: "Страхование",
    desc: "Помогаем страховым компаниям адаптироваться к современным технологиям, повышая эффективность, снижая затраты и улучшая клиентский опыт. Обеспечиваем интеграцию инновационных IT-решений, которые способствуют ускорению обработки данных, улучшению риск-менеджмента и оптимизации взаимодействия с клиентами.",
    Svg: Web,
    logoData: [Rennisanse],
  },
  {
    title: "Безопасность",
    desc: "Создаем надежную и устойчивую систему защиты информации. Используем передовые технологии и методы для обеспечения конфиденциальности, целостности и доступности ваших данных. Сотрудничая с нами, вы получаете доступ к высококвалифицированным специалистам и инновационным инструментам, которые помогут вам защитить ваши цифровые ресурсы и минимизировать риски кибератак.",
    Svg: Lock,
    logoData: [Echelon],
  },
  {
    title: "Медтех",
    desc: "Реализовываем потенциал современных технологий для повышения качества медицинских услуг и улучшения результатов лечения. Обеспечиваем высокую надежность и безопасность медицинских данных, соблюдение нормативных требований, а также оптимизацию рабочих процессов и улучшение взаимодействия между медицинскими устройствами и системами.",
    Svg: Heart,
    logoData: [Medsi],
  },
  {
    title: "ML",
    desc: "Помогаем использовать потенциал машинного обучения для трансформации вашего бизнеса. Обеспечиваем полную поддержку на всех этапах реализации ML-проектов, от концепции до внедрения и оптимизации. Сотрудничая с нами, вы получаете доступ к высококвалифицированным специалистам и передовым технологиям, которые помогут вам извлечь максимальную пользу из ваших данных.",
    Svg: Robot,
    logoData: [Vsporte],
  },
];

export const textData = {
  section: {
    title: "Развиваем отрасли",
    description:
      "Специализируемся на проектах цифровой трансформации бизнеса с учетом отраслевой специфики.",
  },
  main: "MAIN-01",
};
